<pre class="hljs">
    <code [innerHtml]="codeHtmlContent">
    </code>
</pre>
